// Data loading for the Operations Console (Mission Control Phase 1).
// One server-side round-trip to the admin-gated ops-console-overview edge
// function. No polling, no realtime — the page loads once and refreshes on
// explicit user action.

import { supabase } from '../supabase';

export type HealthStatus = 'healthy' | 'warning' | 'offline' | 'unknown';

export type HealthKey = 'app' | 'api' | 'database' | 'google' | 'openai' | 'revenuecat' | 'sentry';

export interface SwitchRow {
  key: string;
  value: unknown;
  client_safe: boolean;
  expires_at: string | null;
  updated_at: string | null;
  reason: string | null;
  actor: string | null;
  description: string | null;
}

export interface AuditRow {
  at: string;
  actor: string;
  key: string;
  old_value: unknown;
  new_value: unknown;
  reason: string | null;
}

export interface OverviewPayload {
  asOf: string;
  health: Record<HealthKey, HealthStatus>;
  switches: SwitchRow[];
  audit: AuditRow[];
  infrastructure: {
    currentAppVersion: string | null;
    minimumSupportedVersion: { ios: string; android: string };
    maintenanceFull: boolean;
    maintenanceBanner: boolean;
    degradedMode: boolean;
    repliesEnabled: boolean;
    googleSyncEnabled: boolean;
  };
  stats: {
    totalSwitches: number;
    activeTemporary: number;
    expiredPending: number;
    auditToday: number;
  };
}

export async function loadOpsOverview(): Promise<OverviewPayload> {
  const { data, error } = await supabase.functions.invoke<OverviewPayload>(
    'ops-console-overview',
    { body: {} },
  );
  if (error) throw new Error(error.message);
  if (!data) throw new Error('Empty response from ops-console-overview.');
  return data;
}
